export default __webpack_public_path__ + "static/media/entertainment-curve.f6d2e4f7.svg";